var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{ref:"canvas",staticClass:"canvas"}),(_vm.bpmnModeler)?_c('x-bpmn-property-panel',{staticClass:"properties-panel-wrapper",attrs:{"modeler":_vm.bpmnModeler}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }